










































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  ICarJob,
  IJobDetail,
  // JOB_TYPES,
  TFormValidator,
  IWhoAmI,
  ICustTypeDto,
  IServiceDTO,
  JOB_TYPES,
  SUB_TYPE,
} from "@/interfaces";
import { makeCarJob, makeJobDetail } from "@/utils";
import { REQUIRED_RULE, VIN_RULES, 
PRICE_REQ_RULES, 
PRICE_REQ_RULES2, 
LOOSE_WHEEL_RULES, 
PRICE_QTY_RULES } from "@/validators";
import MoneyField from "./money-field.vue";
import { HELPER } from "@/utils/Helper";
import NonZeroInput from '../../common/non-zero-input.vue'

@Component({ components: { MoneyField, NonZeroInput } })
export default class VehicleFormComponent extends Vue {
  @Prop({ required: true }) carJobs: ICarJob[];
  @Prop({ default: 0 }) public subtotal!: number;

  @Prop({ default: true }) public custType: ICustTypeDto;

  public mounted() {}

  public carJobsItems: ICarJob[] = [];
  public valid = true;

  public required = REQUIRED_RULE;
  public vinRules = VIN_RULES;
  public priceRules = PRICE_REQ_RULES;
  public priceRules2 = PRICE_REQ_RULES2;
	public lwrules: any = LOOSE_WHEEL_RULES;
	public qtyrules: any = PRICE_QTY_RULES;




  @Watch("carJobs")
  public update() {
    this.carJobsItems = [...this.carJobs];
  }



  @Watch("showMaterialCharge", { immediate: true })
  public materialChargeChanged(currVal: boolean, oldVal: boolean) 
	{
    if (currVal == false) {
      /* WE NEED TO REMOVE THE MATERIAL CHARGES.
       */
      var actions: boolean = false;

			if (!this.carJobsItems|| this.carJobsItems.length==0)
				return;

      this.carJobsItems.filter((j) => {
        var deets = j.JobDetails.filter((jd) => {
          if (jd.JobType == JOB_TYPES.MaterialCharge) {
            return true;
          }
          return false;
        });

        if (deets && deets.length > 0) {
          actions = true;

          deets.forEach((i) => {
            var iof = j.JobDetails.indexOf(i);
            j.JobDetails.splice(iof, 1);
          });
        }
      });

      if (actions) {
        this.updateCarJobs();
      }
    }
  }

  ServiceSelected(a: IJobDetail) {
		var serv = this.Services_.filter(s=>s.RecordID==a.ServiceItemID);
		var servName = "-- not found --";
		var st = JOB_TYPES.Other;
		if (serv!=null && serv.length>0){
			servName = serv[0].ServiceScopedName;
			st = serv[0].ServiceType;
		}
		a.ServiceItemName = servName;
		a.JobType = st;

		this.updateJobType(a);
	}

  addItem(t: SUB_TYPE): void 
	{
		var cj = makeCarJob({});
		cj.SubType = t;
    this.carJobsItems = [...this.carJobsItems, cj];
    this.updateCarJobs();

		/*
		FOR LOOSE WHEEL, WE 3 RIGHT AWAY 
		BECAUSE IT DOES NOT COLLECT CAR INFORMATION.
		*/
		if (t== SUB_TYPE.LooseWheel){
			this.addService(cj);
		}
  }

  deleteItem(item: ICarJob, i: number) {
    let items: ICarJob[] = [];
    this.carJobsItems.forEach((it, j) => {
      if (i !== j) items.push(it);
    });
    this.carJobsItems = [...items];
    this.updateCarJobs();
  }

  addService(item: ICarJob) {
    if (!item.JobDetails) item.JobDetails = [];

    var jd = makeJobDetail({});
		// jd.ServiceQty = null;
		// jd.LooseWheelCount = null;
    this.SetServicePrice(jd);

    item.JobDetails = [...item.JobDetails, jd];
    this.updateCarJobs();
  }

  deleteDetail(item: ICarJob, j: number) {
    let items: IJobDetail[] = [];
    item.JobDetails.forEach((it, i) => {
      if (i !== j) items.push(it);
    });
    item.JobDetails = [...items];
    this.updateCarJobs();
  }

  @Getter("materialCharge", { namespace: "AppModule" })
  public materialChargeAmount: number;

  @Getter("user", { namespace: "AppModule" })
  public whoAmI: IWhoAmI;

  @Getter("serviceItems", { namespace: "AppModule" })
  public Services_: IServiceDTO[];

  get showMaterialCharge(): boolean {
    return HELPER.HasFlag2(this.custType, 110);
  }

  get showAdditionalFields(): boolean {
    return !HELPER.HasFlag2(this.custType, 90);
  }

	get actualServices(): IServiceDTO[] 
	{
		var rval = this.Services_.filter(s=>
		(this.showMaterialCharge || (s.ServiceType!= JOB_TYPES.MaterialCharge)));
		return rval;
	}


  updateJobType(deet: IJobDetail) {
    /* 
			IF THE USER SELECTS MATERIAL-CHARGE, PRESETS A PRICE. 
			
			PRICES WILL CHANGE EVERY TIME THE SERVICE CHANGES,
			REGARDLESS OF THE PREVIOUS PRICE ENTERED / SELECTED.

			THIS LOGIC IS CLEANER. IF YOU CHANGE THE DDN, THE PRICE
			WILL CHANGE, IF YOU DON'T, THE PRICE WILL REMAIN.
		*/
    if (deet.JobType == JOB_TYPES.MaterialCharge)
    {
      deet.PricePerWheel = this.materialChargeAmount;
    }
		else
		{
			/* IF THE SERVICE IS NOT MATERIAL CHARGE, GET
			THE CORRESPONDING TECH PRICE FOR THE SERVICE.
			*/
	    this.SetServicePrice(deet);
		}


    this.updateCarJobs();
	}


  private SetServicePrice(s: IJobDetail) 
	{
		var search = this.Services_.find(s2=>s2.RecordID == s.ServiceItemID);
		if (search){
			s.PricePerWheel = search.TechPpw;
		}
		/// COMMENTING OUT THE PREVIOUS LOGIC, WHERE WE WOULD 
		/// CHECK IF THE USER WAS DEALERSHIP OR RETAIL.
		/// 
    // var ppw = 0;
    // if (this.custType.IsDealership) ppw = this.whoAmI.PpwDealership;
    // if (this.custType.IsRetail) ppw = this.whoAmI.PpwRetail;
    // s.PricePerWheel = ppw;
	}


  updateCarJobs() {
    this.carJobsItems.forEach((ji) => {
      ji.JobDetails.forEach((jb) => {
        var totalWheels = 0;

				/* 
				THE WHEEL COUNT ARRIVES FROM DIFFERENT SOURCES
				DEPENDING ON THE JOB SUB TYPE. 
				 */
				if (ji.SubType== SUB_TYPE.Vehicle){
					// var wheels = [jb.WheelFR, jb.WheelFL, jb.WheelBR, jb.WheelBL];
					// totalWheels = wheels.filter((w) => w).length;
					totalWheels = jb.ServiceQty;
				}

				if (ji.SubType== SUB_TYPE.LooseWheel)
					totalWheels = jb.LooseWheelCount;

        jb.JobPrice = totalWheels * jb.PricePerWheel;
      });
    });

    this.$emit("update-car-jobs", this.carJobsItems);
  }

  validate() {
    return (this.$refs.vehiclesForm as HTMLFormElement).validate();
  }
}
